var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@core';
import { convertToClientReportFormFlags } from '@features/constructor/converters';
import { getReportFormInfo } from '@features/constructor/services';
import { FormReportConfig } from '@features/constructor/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { catchError, from } from 'rxjs';
import { DocumentFlags } from './document-flags.component';
import { GeneralInfoForm } from './general-info-form.component';
var ReportFromComponent = function () {
    var search = useSearchParams()[0];
    var reportId = search.get('reportId');
    var form = useForm({
        resolver: zodResolver(FormReportConfig.schema),
        defaultValues: FormReportConfig.defaultValues,
    });
    useEffect(function () {
        if (!reportId)
            return;
        from(getReportFormInfo(reportId))
            .pipe(catchError(function () {
            return [];
        }))
            .subscribe(function (response) {
            if (response.status === 200)
                form.setValue('floorDocumentsFlags', convertToClientReportFormFlags(response.data));
        });
    }, [reportId]);
    return (_jsx(FormProvider, __assign({}, form, { children: _jsxs("div", __assign({ className: "flex size-full flex-col items-center gap-[50px] rounded-lg bg-white p-[50px]" }, { children: [_jsx("p", __assign({ className: "font-sans text-lg font-semibold leading-4" }, { children: "\u0424\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0442\u0447\u0435\u0442\u0430" })), _jsx(GeneralInfoForm, {}), _jsx(DocumentFlags, {}), _jsxs("div", __assign({ className: "flex w-full items-center justify-end gap-[50px]" }, { children: [_jsx(Button, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C" }), _jsx(Button, { children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })] }))] })) })));
};
export default ReportFromComponent;
